import { createAction } from "@reduxjs/toolkit";

export const FETCH_LIST_EXAM_STUDENT = 'FETCH_LIST_EXAM_STUDENT';
export const START_EXAM = 'START_EXAM';
export const STUDENT_ANSWER_QUESTION_EXAM = 'STUDENT_ANSWER_QUESTION_EXAM';
export const STUDENT_FINISH_EXAM = 'STUDENT_FINISH_EXAM';
export const FETCH_EXAM_QUESTION_STATUS = 'FETCH_EXAM_QUESTION_STATUS';
export const fetchListExamStudent = createAction(FETCH_LIST_EXAM_STUDENT);
export const fetchExamQuestionStatus = createAction(FETCH_EXAM_QUESTION_STATUS, (examSessionId: number | string) => ({ payload: { examSessionId } }));
export type StartExamPayload = {
  moduleId: string
  classId: string
  submodule_class_practice_id?: number
  exam_extend_id?: number
}
export const startExam = createAction(START_EXAM, (payload: StartExamPayload) => ({ payload }))

export const studentAnswerQuestion = createAction(STUDENT_ANSWER_QUESTION_EXAM, ((questionId: string) => ({
  payload: {
    questionId
  }
})))

export const studentFinishExam = createAction(STUDENT_FINISH_EXAM,  (moduleId: string) => ({
  payload: {moduleId}
}))